import React, { useEffect } from "react";
import { useHistoryOperations } from "@/hooks/useHistoryOperations";
import { EntityHistory } from "@/components/common/EntityHistory";
import { useTranslation } from "react-i18next";

interface CompanyHistoryTabProps {
  companyId: string;
}

export const CompanyHistoryTab = ({ companyId }: CompanyHistoryTabProps) => {
  const { history, loading, fetchHistory } = useHistoryOperations('company');
  const { t } = useTranslation();

  // Fetch history when component mounts
  useEffect(() => {
    if (companyId) {
      fetchHistory(companyId);
    }
  }, [companyId, fetchHistory]);

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">{t("companies.detail.tabs.history")}</h3>
      <EntityHistory history={history} loading={loading} />
    </div>
  );
};
